import {GatewayState, RootState, Device, Gateway} from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import { chunk } from 'lodash';
import GatewayService from '@/services/gateway.service';

type GatewayGetter = GetterTree<GatewayState, RootState>;

export const initialState = (): GatewayState => {
  return {
    initialState,
    gateways: [],
    useGatewaySubscriptions: process.env.VUE_APP_FEATURE_GATEWAY_SUBSCRIPTIONS === 'true',
  };
};

export const getters: GatewayGetter = {
  gateways: (state) => state,
  useGatewaySubscriptions: (state) => state.useGatewaySubscriptions,
};

export const mutations: MutationTree<GatewayState> = {
  setUseGatewaySubscriptions(state) {
    state.useGatewaySubscriptions = process.env.VUE_APP_FEATURE_GATEWAY_SUBSCRIPTIONS === 'true';
  },
};

export const actions: ActionTree<GatewayState, RootState> = {
  async unpairSimsFromGateways(context: any, gatewayIds: number[]) {
    let countCompleted = 0;
    const updatedGateways: Gateway[] = [];
    try {
      const batches = chunk(gatewayIds, 50);
      for (const ids of batches) {
        const gatewaysToUpdate = await GatewayService.unpairSims( ids );
        for (const g of gatewaysToUpdate) {
          updatedGateways.push(g);
        }
        countCompleted += ids.length;
      }
    } catch (e) {
      const err = e as Error;
      if (countCompleted === 0) {
        throw e;
      } else {
        throw new Error(`Failed to unpair ${gatewayIds.length - countCompleted} out of ${gatewayIds.length} gateways. ${err.message}`);
      }
    } finally {
      /*if (updatedGateways.length) {
        context.commit('updateGateways', updatedGateways);
      }*/
    }
    return updatedGateways;
  },
};

export const gateways: Module<GatewayState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
